import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../../../enum/constant";

const StoreNewBank = ({ currency }) => {
  const initialFormData = {
    id: "",
    bank_name: "",
    bic_swift: "",
    supported_payments: [],
    bank_address: "",
    company_name: "",
    company_address: "",
    account_number: "",
    currency: currency || "0",
    status: 0,
  };

  const [formDataBank1, setFormDataBank1] = useState(initialFormData);
  const [formDataBank2, setFormDataBank2] = useState(initialFormData);
  const [successMessageBank1, setSuccessMessageBank1] = useState("");
  const [successMessageBank2, setSuccessMessageBank2] = useState("");

  useEffect(() => {
    const fetchBankInfo = async () => {
      try {
        let endpoint = "";
        if (currency === "USD") {
          endpoint = baseUrl + "api/adminbank-Usdcurrency";
        } else if (currency === "EUR") {
          endpoint = baseUrl + "api/adminbank-Eurocurrency";
        }

        const response = await axios.get(endpoint);
        const data = Array.isArray(response.data)
          ? response.data
          : [response.data];

        if (data.length > 0) {
          setFormDataBank1({
            ...initialFormData,
            ...data[0],
            supported_payments: data[0].supported_payments
              ? data[0].supported_payments.split(",")
              : [],
          });
        }
        if (data.length > 1) {
          setFormDataBank2({
            ...initialFormData,
            ...data[1],
            supported_payments: data[1].supported_payments
              ? data[1].supported_payments.split(",")
              : [],
          });
        }
      } catch (error) {
        console.error("Error fetching bank info:", error);
      }
    };

    fetchBankInfo();
  }, [currency]);

  const handleInputChange = (e, setFormData, formData) => {
    const { name, value, options, type } = e.target;
    if (type === "select-multiple") {
      const selected = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
      setFormData({
        ...formData,
        [name]: selected,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleStatusChange = (e, setFormData, formData) => {
    setFormData({
      ...formData,
      status: e.target.checked ? 1 : 0,
    });
  };

  const handleSubmit = async (e, formData, setSuccessMessage) => {
    e.preventDefault();
    try {
      const url = formData.id
        ? `${baseUrl}api/adminbank-info/${formData.id}`
        : baseUrl + "api/adminbank-info";
      const method = formData.id ? "put" : "post";

      const payload = {
        ...formData,
        supported_payments: formData.supported_payments.join(","),
      };

      await axios[method](url, payload);
      setSuccessMessage("Bank information stored successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Error saving/updating bank info:", error);
    }
  };

  const renderForm = (
    formData,
    setFormData,
    handleSubmitForm,
    formIndex,
    successMessage
  ) => (
    <>
      {/* {successMessage && (
        <div className="alert alert-success mt-3" role="alert">
          {successMessage}
        </div>
      )} */}
      {successMessage && (
        <div class="cus-alert-msg alert-success" role="alert">
          <div class="icon">✔{/* <i class="bi bi-check-lg"></i> */}</div>
          <p class="message mb-0">{successMessage}</p>
        </div>
      )}

      <form
        onSubmit={handleSubmitForm}
        style={{
          textAlign: "start",
          marginTop: formIndex === 2 ? "30px" : "0",
        }}
      >
        <div className="mb-3">
          <label
            htmlFor={`Activate_${formIndex}`}
            className="form-label Activate"
          >
            Activate
          </label>
          <input
            type="checkbox"
            id={`status_${formIndex}`}
            name="status"
            checked={Number(formData.status) === 1}
            onChange={(e) => handleStatusChange(e, setFormData, formData)}
            className={`mx-2 Activate_${formIndex}n`}
          />
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor={`bank_name_${formIndex}`} className="form-label">
              Bank Name
            </label>
            <input
              type="text"
              className="form-control"
              id={`bank_name_${formIndex}`}
              name="bank_name"
              placeholder="Bank Name"
              value={formData.bank_name}
              onChange={(e) => handleInputChange(e, setFormData, formData)}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label
              htmlFor={`account_number_${formIndex}`}
              className="form-label"
            >
              Bank Account Number
            </label>
            <div className="input-group">
              <span className="input-group-text">{formData.currency}</span>
              <input
                type="text"
                className="form-control"
                id={`account_number_${formIndex}`}
                name="account_number"
                placeholder="Bank Account Number"
                value={formData.account_number}
                onChange={(e) => handleInputChange(e, setFormData, formData)}
                required
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor={`bic_swift_${formIndex}`} className="form-label">
              BIC/Swift
            </label>
            <input
              type="text"
              className="form-control"
              id={`bic_swift_${formIndex}`}
              name="bic_swift"
              placeholder="BIC/Swift"
              value={formData.bic_swift}
              onChange={(e) => handleInputChange(e, setFormData, formData)}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label
              htmlFor={`supported_payments_${formIndex}`}
              className="form-label"
            >
              Supported Payments
            </label>
            <select
              multiple
              className="form-control"
              id={`supported_payments_${formIndex}`}
              name="supported_payments"
              value={formData.supported_payments}
              onChange={(e) => handleInputChange(e, setFormData, formData)}
              required
              style={{ fontSize: "14px", height: "100px" }}
            >
              <option value="SEPA">SEPA</option>
              <option value="SWIFT">SWIFT</option>
            </select>
            <small className="text-muted">
              Hold Ctrl (Cmd on Mac) to select multiple
            </small>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 mb-3">
            <label htmlFor={`bank_address_${formIndex}`} className="form-label">
              Bank Address
            </label>
            <input
              type="text"
              className="form-control"
              id={`bank_address_${formIndex}`}
              name="bank_address"
              placeholder="Bank Address"
              value={formData.bank_address}
              onChange={(e) => handleInputChange(e, setFormData, formData)}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mb-3">
            <label htmlFor={`company_name_${formIndex}`} className="form-label">
              Company Name
            </label>
            <input
              type="text"
              className="form-control"
              id={`company_name_${formIndex}`}
              name="company_name"
              placeholder="Company Name"
              value={formData.company_name}
              onChange={(e) => handleInputChange(e, setFormData, formData)}
              required
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 mb-3">
            <label
              htmlFor={`company_address_${formIndex}`}
              className="form-label"
            >
              Company Address
            </label>
            <input
              type="text"
              className="form-control"
              id={`company_address_${formIndex}`}
              name="company_address"
              placeholder="Company Address"
              value={formData.company_address}
              onChange={(e) => handleInputChange(e, setFormData, formData)}
              required
            />
          </div>
        </div>

        <button type="submit" className="btn btn-primary w-30 ">
          Save/Update
        </button>
      </form>
    </>
  );

  return (
    <div className="card mt-2 border-0">
      <div className="card-body">
        {/* Bank 1 Form */}
        {renderForm(
          formDataBank1,
          setFormDataBank1,
          (e) => handleSubmit(e, formDataBank1, setSuccessMessageBank1),
          1,
          successMessageBank1
        )}

        <hr />

        {/* Bank 2 Form */}
        {renderForm(
          formDataBank2,
          setFormDataBank2,
          (e) => handleSubmit(e, formDataBank2, setSuccessMessageBank2),
          2,
          successMessageBank2
        )}
      </div>
    </div>
  );
};

export default StoreNewBank;
